import { forwardRef } from "react";
import type { SVGIconProps } from "../types";

export const CollaboratorIcon = forwardRef<SVGSVGElement, SVGIconProps>(
  function CollaboratorIcon(props, ref) {
    const { size = 24, className, ...rest } = props;
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 8 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...rest}
      >
        <path
          d="M4.00008 5.61958C5.32162 5.61958 6.39294 4.50858 6.39294 3.1381C6.39294 1.76761 5.32162 0.656616 4.00008 0.656616C2.67854 0.656616 1.60722 1.76761 1.60722 3.1381C1.60722 4.50858 2.67854 5.61958 4.00008 5.61958ZM4.00008 5.61958C5.01548 5.61958 5.98929 6.03789 6.70729 6.78247C7.42529 7.52706 4.80066 11.0199 4.00008 11.8205C3.19515 11.0155 0.574874 7.52706 1.29287 6.78247C2.01087 6.03789 2.98468 5.61958 4.00008 5.61958Z"
          stroke="#646467"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
